module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_sns_06-cb4435fbbd95f9167b58f0b94445fde3.jpg";